export const LOAD_CONTENT_TIME = 'LOAD_CONTENT_TIME'
export const LOAD_DISCIPLINES = 'LOAD_DISCIPLINES'
export const LOAD_EDITABLE_SCHEDULE_CONFIG = 'LOAD_EDITABLE_SCHEDULE_CONFIG'
export const LOAD_STUDY_MATERIALS = 'LOAD_STUDY_MATERIALS'
export const RESET_SCHEDULE_CONFIG = 'RESET_SCHEDULE_CONFIG'
export const SET_API_ERRORS = 'SET_API_ERRORS'
export const SET_CREATION_STEP = 'SET_CREATION_STEP'
export const SET_IS_UPDATE = 'SET_IS_UPDATE'
export const SET_SCHEDULE_COLOR = 'SET_SCHEDULE_COLOR'
export const SET_SCHEDULE_COURSES = 'SET_SCHEDULE_COURSES'
export const SET_SCHEDULE_DAILY_STUDY_TIME = 'SET_SCHEDULE_DAILY_STUDY_TIME'
export const SET_SCHEDULE_DATES = 'SET_SCHEDULE_DATES'
export const SET_SCHEDULE_ID = 'SET_SCHEDULE_ID'
export const SET_SCHEDULE_DISCIPLINES = 'SET_SCHEDULE_DISCIPLINES'
export const SET_SCHEDULE_MATERIALS = 'SET_SCHEDULE_MATERIALS'
export const SET_SCHEDULE_MODULES = 'SET_SCHEDULE_MODULES'
export const SET_SCHEDULE_WEEKDAYS = 'SET_SCHEDULE_WEEKDAYS'
